"use strict";

import BaseModel from "dias/core/models/baseModel";

class Workflowfolgeserverfunktion extends BaseModel {
  constructor() {
    super("serverfunktionen");
  }
}

export default Workflowfolgeserverfunktion;
